export const ExecutiveSummaryEntityType = {
  CLIENT: 'client',
  CLIENT_GROUP: 'client_group',
};

export const ExecutiveSummariesEventType = {
  ON_SAVE_EXECUTIVE_SUMMARY_ITEM: 'on-save-executive-summary-item',
  ADD_EXECUTIVE_SUMMARY: 'add-executive-summary',
  PANEL_OPEN: 'executive-summary-open',
  EXECUTIVE_SUMMARY_LEGACY_EVENT: 'ExecutiveSummaryLegacyEvent',
  EXECUTIVE_SUMMARY_ADD_OR_EDIT_SUMMARY_LEGACY_EVENT: 'ExecutiveSummaryAddOrEditSummaryLegacyEvent',
  EXECUTIVE_SUMMARY_DELETE_SUMMARY_LEGACY_EVENT: 'ExecutiveSummaryDeleteSummaryLegacyEvent',
  EXECUTIVE_SUMMARY_REPORT_STUDIO_SAVED: 'executive-summary-report-studio-saved',
};

export const SettingsConstants = {
  ID: 'id',
  TITLE: 'title',
};

export const ExecutiveSummariesRoute = {
  EXECUTIVESUMMARIES: 'executivesummaries',
};

export const ExecutiveSummariesPathName = {
  EXECUTIVESUMMARIES: 'executivesummaries',
};

export const ListTypes = {
  DASHBORD: 'dashboard',
  REPORT_STUDIO: 'report_studio',
};
